import React from 'react'
import { connect } from 'react-redux'

import TimeTotalDisplay from './components/TimeTotalDisplay'
import FiltersPanel from '../FiltersPanel'
import DaysView from './components/DaysView'
import Layout from '../Layout'
import TimeMoneyToggler from '../TimeMoneyToggler'
import TasksPanel from './components/TasksPanel'
import Preloader from '../UI/Preloader'
import * as appActions from '../../App/actions'

class TimeSheet extends React.Component {
  componentDidMount = () => {
    this.props.getReportTasksRequest()
  }

  render() {
    const { loading } = this.props
    const content = (
      <React.Fragment>
        <div className="main_workspace">
          <div className="main_workspace_header">
            <h1>Time Sheet</h1>
            {loading && <Preloader mini />}
            {!loading && <TimeTotalDisplay />}
          </div>
          <FiltersPanel />
          {loading && <Preloader />}
          {!loading && <DaysView />}
        </div>
        <div className="main_controls">
          <TimeMoneyToggler />
          {loading && <Preloader mini />}
          {!loading && <TasksPanel />}
        </div>
      </React.Fragment>
    )
    return <Layout content={content} />
  }
}

const mapStateToProps = state => ({
  loading: state.app.appState.loading
})

const mapDispatchToProps = dispatch => ({
  getReportTasksRequest: () => dispatch(appActions.getReportTasksRequest())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeSheet)
